import { Box, Checkbox, Typography } from '@mui/material';
import { Device } from './types';

interface DeviceCheckboxProps {
  device: Device;
  bargeName: string;
  isChecked: boolean;
  onChange: (device: Device & { bargeName: string }) => void;
}

export const DeviceCheckbox = ({ device, bargeName, isChecked, onChange }: DeviceCheckboxProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
        width: '100%',
      }}
    >
      <Checkbox
        sx={{
          p: 0,
          mr: 1,
          '& .MuiSvgIcon-root': {
            color: '#989B9C',
            width: '23px',
            height: '23px',
          },
          '&.Mui-checked': {
            '& .MuiSvgIcon-root': {
              color: 'primary.main',
            },
          },
        }}
        // size="small"
        checked={isChecked}
        onChange={() => onChange({ ...device, bargeName })}
      />
      <Typography
        sx={{
          lineHeight: '32px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          pr: 1,
        }}
      >
        {device.name}
      </Typography>
    </Box>
  );
};
